// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__lsV9j","busy":"Header_busy__3WC9k","time":"Header_time__1hQKd","title":"Header_title__1px5r","buttons":"Header_buttons__33IGX"};